<template lang="pug">
    #score68-preview
        .picture
            .footballer
        .columns
            .description.column.is-three-fifths-fullhd.is-four-fifths-desktop
                .columns
                    .column
                        span.subtitle.has-text-success.has-text-right PREMATCH
                        span.subtitle.has-text-warning.has-text-right LIVE
                    .column
                        .title BOT
                .columns
                    .column
                    .column
                        ul.info
                            li(v-for="i in 5") + {{ $t(`landing.${i}`) | capitalize }}
                .columns
                    .column
                        router-link.button.is-success(:to="to") {{ $t("landing.join") }}
                    .column
                        router-link.button.is-text(to="/about_us") {{ $t("landing.learn_more") | capitalize }}
</template>

<script>
export default {
  name: "SubscribePreview",
  data: () => ({
    info: [
      "Все лиги и соревнования",
      "Внимание к деталям",
      "Отсутствие человеческого фактора",
      "Непрерывная работа",
      "Доступность 24/7"
    ]
  }),
  computed: {
    to() {
      return this.$store.getters.isAuth ? "/subscriptions" : "/registration";
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../scss/variables" as *;
#score68-preview {
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: center;
  min-height: calc(100vh - 23.5rem);
  width: 100%;
  font-family: "Segoe UI", sans-serif;
  box-shadow: 0 1px 10px 1px rgba(0, 0, 0, 0.3);

  .picture {
    position: absolute;
    height: 100%;
    width: 100%;
    .footballer {
      position: absolute;
      height: 100%;
      width: 100%;
      background-image: url("~@/assets/images/score68.png"),
        url("~@/assets/images/lines.png");
      background-size: contain, contain;
      background-repeat: no-repeat, no-repeat;
      background-position: left center, -5vw center;
      z-index: 1;

      @media screen and (max-width: $desktop - 1) {
        background-size: cover;
        background-position: center;
      }
    }
  }

  & > .columns {
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    z-index: 10;

    @media screen and (max-width: $fullhd) {
      background-color: rgba(0, 0, 0, 0.3);
    }

    .description {
      padding: 3rem 0;
      z-index: 1;

      .columns {
        .title,
        .subtitle {
          font-style: italic;
          font-weight: 900;
        }

        .title {
          color: var(--font-color);
          font-size: 8rem;
        }

        .subtitle {
          font-size: 4rem;
          width: 100%;
          display: inline-block;
          margin-bottom: 0;
          line-height: 3rem;
        }

        &:first-child {
          @media screen and (min-width: $desktop) {
            .column:first-child {
              padding-top: 2rem;
            }
          }
          @media screen and (max-width: $desktop - 1) {
            .column {
              padding: 0 1rem;
              &:last-child {
                text-align: right;
              }
            }
          }
        }

        .info {
          padding: 0 0.5rem 0.5rem;
          font-style: italic;
        }

        .button {
          color: var(--font-color);
          text-transform: uppercase;
          font-weight: bold;

          &.is-text {
            font-size: 0.9em;
            transition: all 0.2s linear;
            height: 3em;
            font-weight: bold;

            &:hover {
              background-color: transparent;
              opacity: 0.8;
            }
          }

          &.is-success {
            padding: 0 3rem;
            font-size: 2em;
            line-height: 0.8rem;
            height: 2em;
            border-radius: 0;
          }
        }

        &:last-child {
          .column {
            display: flex;
            align-items: center;
            @media screen and (max-width: $desktop - 1) {
              justify-content: center !important;
            }
            &:first-child {
              justify-content: flex-end;

              @media screen and (min-width: $desktop) {
                .button {
                  margin-right: 2rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
